import { render } from "./LangSelect.vue?vue&type=template&id=7c46d20c&scoped=true"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"

import "./LangSelect.vue?vue&type=style&index=0&id=7c46d20c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c46d20c"]])

export default __exports__